(() => {
  const preferenceKey = 'co-preferred-language';

  function rememberLanguage(language) {
    const normalised = globalThis.CarOptionsMarketLocalization?.normaliseLanguage(language) || '';
    if (!normalised) return;
    try {
      globalThis.localStorage?.setItem(preferenceKey, normalised);
    } catch (_) {
    }
  }

  function initialiseMenu(menu) {
    if (!menu || menu.dataset.coLanguageReady === 'true') return;
    menu.dataset.coLanguageReady = 'true';

    const moreButton = menu.querySelector('[data-co-lang-more]');
    if (moreButton) {
      moreButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const expanded = !menu.classList.contains('is-expanded');
        menu.classList.toggle('is-expanded', expanded);
        moreButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        const label = moreButton.querySelector('[data-co-lang-more-label]');
        if (label) label.textContent = expanded ? moreButton.dataset.lessLabel : moreButton.dataset.moreLabel;
      });
    }

    menu.querySelectorAll('[data-co-language-choice]').forEach((choice) => {
      choice.addEventListener('click', () => rememberLanguage(choice.dataset.coLanguageChoice));
    });
  }

  function initialise(root = globalThis.document) {
    root.querySelectorAll?.('[data-co-language-menu]').forEach(initialiseMenu);
  }

  if (globalThis.document?.readyState === 'loading') {
    globalThis.document.addEventListener('DOMContentLoaded', () => initialise());
  } else {
    initialise();
  }
  globalThis.document?.addEventListener('shopify:section:load', (event) => initialise(event.target));

  globalThis.CarOptionsLanguageSelector = Object.freeze({ initialise, rememberLanguage });
})();
